"use client";
import type { ComponentProps } from "react";
import { createPortal } from "react-dom";
import { Toaster } from "react-hot-toast";
import { useClientSide } from "../../hooks";

export type CyToasterProps = ComponentProps<typeof Toaster>;
export function CyToaster(props: CyToasterProps) {
  const client = useClientSide();
  if (typeof document === "undefined" || !client) {
    return null;
  }
  return <>{createPortal(<Toaster {...props} />, document.body)}</>;
}
